import { render, staticRenderFns } from "./ShortButton.vue?vue&type=template&id=69f69df4&scoped=true&"
import script from "./ShortButton.vue?vue&type=script&lang=js&"
export * from "./ShortButton.vue?vue&type=script&lang=js&"
import style0 from "./ShortButton.vue?vue&type=style&index=0&id=69f69df4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f69df4",
  null
  
)

export default component.exports